import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
    return (
        <div className="loader-container">
            <div className="loader2"></div>
            <p>Processing...</p>
        </div>
    );
};

export default LoadingSpinner;
